<template>
  <v-data-table
    :items="allPayments"
    :headers="headers"
    :item-class= "row_classes"                  
    mobile-breakpoint="0"
    hide-default-footer
    class="rounded-lg mt-2"
    style="overflow-y: auto;"
  >
    <template #item.payment_date="{ item }">
      <router-link :to="{ name: 'payments/show', params: { payment_id: item.payment_id } }">
        {{ formatDate(item.payment_date) }}
      </router-link>
    </template>

    <template #item.method="{ item }">
      {{ brandWord(item.payment_method.brand) }} *-{{ item.payment_method.last4 }}
    </template>

    <template #item.collected_cents="{ item }">
      {{ formatCurrency(item.collected_cents) }}
    </template>
  </v-data-table>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'BillingPaymentsTab',

  data: () => ({
    headers: [
      { text: 'Date', value: 'payment_date',  class: 'fitwidth pr-2', cellClass: 'fitwidth pr-2' },
      { text: 'Method', value: 'method', class: 'fitwidth px-2', cellClass: 'fitwidth px-2' },
      { text: 'Status', value: 'status', align: 'center', class: 'fitwidth px-2', cellClass: 'fitwidth px-2' },
      { text: 'Amount', value: 'collected_cents', align: 'end', class: 'fitwidth pl-2', cellClass: 'fitwidth pl-2' },
    ],

    selected: null,
  }),

  computed: {
    ...mapGetters('billing', ['allPayments'])
  },

  methods: {
    ...mapActions('billing', ['loadAllPayments']),
    ...formatters,

    row_classes(row) {
      if (row.payment_id == this.selected) {
        return "font-weight-bold"
      } 
    },
  },

  created() {
    this.loadAllPayments()

    const urlParams = new URLSearchParams(window.location.search)
    this.selected = parseInt(urlParams.get('payment_id'))
  },
}
</script>

<style>
  .fitwidth {
    width: 1px;
    white-space: nowrap;
  }
</style>
